export const ROLES = [
  { value: 'admin', label: 'Beheerder', color: 'bg-purple-100 text-purple-700' },
  { value: 'zoea_admin', label: 'Zoea Admin', color: 'bg-teal-100 text-teal-700' },
  { value: 'teamleader', label: 'Teamleider', color: 'bg-blue-100 text-blue-700' },
  { value: 'hoofd_facilitair', label: 'Hoofd facilitair', color: 'bg-amber-100 text-amber-700' },
  { value: 'connectleider', label: 'Connectleider', color: 'bg-emerald-100 text-emerald-700' },
  { value: 'connectlesmaker', label: 'Connectlesmaker', color: 'bg-fuchsia-100 text-fuchsia-700' },
  { value: 'leiderschap', label: 'Leiderschap', color: 'bg-indigo-100 text-indigo-700' },
  { value: 'pastor', label: 'Voorganger', color: 'bg-violet-100 text-violet-700' },
  { value: 'worshipleader', label: 'Worshipleader', color: 'bg-rose-100 text-rose-700' },
  { value: 'coordinator_worship', label: 'Worshipcoördinator', color: 'bg-pink-100 text-pink-700' },
  { value: 'worshipteamlid', label: 'Worshipteamlid', color: 'bg-cyan-100 text-cyan-700' },
  { value: 'kinderwerkleider', label: 'Kinderwerkleider', color: 'bg-orange-100 text-orange-700' },
  { value: 'kinderwerkvrijwilliger', label: 'Kinderwerkvrijwilliger', color: 'bg-lime-100 text-lime-700' },
  { value: 'coordinator_kinderwerk', label: 'Kinderwerkcoördinator', color: 'bg-yellow-100 text-yellow-700' },
  { value: 'alpha_coordinator', label: 'Alpha-coördinator', color: 'bg-sky-100 text-sky-700' },
  { value: 'secretariaat', label: 'Secretariaat', color: 'bg-teal-100 text-teal-700' },
  { value: 'employee', label: 'Medewerker', color: 'bg-slate-100 text-slate-700' },
];

export default ROLES;
